<template>
    <q-select
        v-model="input"
        class="regularFontSize color__blackOnDisabled"
        popup-content-class="regularFontSize"
        :options="customOptions"
        option-label="description"
        option-value="itemCode"
        label="Select Items"
        multiple
        use-input
        input-debounce="0"
        emit-value
        map-options
        @filter="filterElements"
        :popup-content-style="{
            width: '100px',
        }"
        :rules="rules"
    >
        <!-- Dropdown options -->
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps" :disable="scope.selected">
                <q-item-section>
                    <q-item-label>
                        <strong>{{ scope.opt.itemDesc }}</strong>
                    </q-item-label>

                    <q-item-label caption>
                        {{ scope.opt.itemCode }}
                    </q-item-label>
                </q-item-section>

                <q-item-section side>
                    <q-checkbox :value="scope.selected" @input="scope.toggleOption(scope.opt)" />
                </q-item-section>
            </q-item>
        </template>

        <!-- Selected items inside select -->
        <template v-slot:selected-item="scope">
            <q-chip removable dense @remove="scope.removeAtIndex(scope.index)"> {{ scope.opt.itemCode }} - {{ scope.opt.description }} </q-chip>
        </template>
    </q-select>
</template>
<script>
export default {
    props: ['disable', 'label', 'model', 'value', 'options', 'error', 'loading', 'rules', 'isOptionSlot'],
    data() {
        return {
            selectedItems: [],
            filteredOptions: [],
            customOptions: [],
            input: '',
        };
    },
    mounted() {
        this.input = this.value;
        this.customOptions = this.options;
        this.filteredOptions = this.customOptions;
    },
    methods: {
        filterElements(val, update) {
            update(() => {
                const needle = (val || '').toLowerCase().trim();

                if (!needle) {
                    this.customOptions = [...this.filteredOptions];
                    return;
                }

                this.customOptions = this.filteredOptions.filter((item) =>
                    this.isOptionSlot
                        ? String(item.itemDesc).toLowerCase().includes(needle) || String(item.itemSkuCode).toLowerCase().includes(needle)
                        : String(item).toLowerCase().includes(needle)
                );
            });
        },
        onChange() {
            this.$emit('change', this.model, this.input);
            if (this.label.toLowerCase().includes('warehouse')) {
                this.$emit('input', this.input);
            }
        },
        setValue(val) {
            this.input = val;
        },
        required(value) {
            return !!value || 'This field is required';
        },
    },
    watch: {
        options(newVal) {
            // Update dropdown options
            this.customOptions = newVal;

            // Also update the list used for filtering
            this.filteredOptions = [...newVal];

            // Debug
        },
        value(newVal) {
            this.input = newVal;
        },
    },
};
</script>